import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enResources from './locales/en.json';
import msResources from './locales/ms.json';

const resources = {
    en: { translation: enResources },
    ms: { translation: msResources }
};


i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        //lng: 'bm',
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export default i18n;